module.exports = __webpack_public_path__ + "img/7.aac6ce3a.jpg";